var map = {
	"./cancelled-icon.png": "539b",
	"./confirmed-gray-icon.png": "38c4",
	"./confirmed-icon.png": "edf3",
	"./ic_order_canceled_customer_circle_filled.png": "bae8",
	"./ic_order_canceled_staff_circle_filled.png": "2583",
	"./ic_order_close_circle_filled.png": "8e24",
	"./ic_order_confirmed_circle_filled.png": "dbd2",
	"./ic_order_new_circle_filled.png": "68b4",
	"./ic_order_pack_circle_filled.png": "eebc",
	"./ic_order_preparing_circle_filled.png": "66f7",
	"./ic_order_ready_circle_filled.png": "e198b",
	"./ic_order_rejected_circle_filled.png": "4153",
	"./new-icon.png": "8ebf",
	"./preparing-gray-icon.png": "494b",
	"./preparing-icon.png": "009d",
	"./ready-gray-icon.png": "a601",
	"./ready-icon.png": "d459",
	"./rejected-icon.png": "ee57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";